export const SET_FILE_LOGS_LOADING = 'file-logs/SET_FILE_LOGS_LOADING';
export const SET_FILE_LOGS_DATA = 'file-logs/SET_FILE_LOGS_DATA';
export const SHOW_BATCH_FILE_UPLOAD_MODAL = 'file-logs/SHOW_BATCH_FILE_UPLOAD_MODAL';
export const HIDE_BATCH_FILE_UPLOAD_MODAL = 'file-logs/HIDE_BATCH_FILE_UPLOAD_MODAL';
export const SET_BATCH_FILE_UPLOAD_LOADING = 'file-logs/SET_BATCH_FILE_UPLOAD_LOADING';
export const SET_BATCH_FILE_UPLOAD_DATA = 'file-logs/SET_BATCH_FILE_UPLOAD_DATA';
export const UPDATE_PAGINATION = 'file-logs/UPDATE_PAGINATION';
// Define the mutation types for the jobQueue module
export const SET_JOB_QUEUE_LOADING_STATE = 'job-queue/SET_JOB_QUEUE_LOADING_STATE';
export const SET_JOB_QUEUE_DATA = 'job-queue/SET_JOB_QUEUE_DATA';
export const SET_PAGE = 'job-queue/SET_PAGE';
export const UPDATE_JOB_QUEUE_DATA = 'job-queue/UPDATE_JOB_QUEUE_DATA';
export const RESET_SEARCH_VALUE = 'job-queue/RESET_SEARCH_VALUE';
export const RESET_FILTER_FIELD = 'job-queue/RESET_FILTER_FIELD';